import { fromJS } from 'immutable';
import { normalizeItems } from '@Utils';
import { breadcrumbsRetrievedType } from './BreadcrumbsConstants';

export const initialState = fromJS({
  ids: [],
  items: {},
});

// eslint-disable-next-line default-param-last
export default function breadcrumbsReducer(state = initialState, action) {
  switch (action.type) {
    case breadcrumbsRetrievedType: {
      const { breadcrumbs } = action;
      const normalized = normalizeItems(breadcrumbs);

      return state.merge(
        fromJS({
          ids: normalized.ids,
          items: normalized.items,
        })
      );
    }
    default: {
      return state;
    }
  }
}
